// extracted by mini-css-extract-plugin
export default {"contentWrapper":"BlogRecomendations_contentWrapper__pVV+q","carousel":"BlogRecomendations_carousel__WFqet"};